import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-gradient-line" />
      <div className="footer-content">
        <span>© {new Date().getFullYear()} Eugen Dunca. All rights reserved.</span>
        <nav className="footer-links">
          <a href="#/">Home</a>
          <a href="#/experience">Contact</a>
          <a href="#/energy">Energy</a>
          <a href="#/robotics">Robotics</a>
          <a href="#/arctic">Arctic</a>
          <a href="#/about">About</a>
        </nav>
        <div className="footer-contact">
          <span>Contact: <a href="mailto:edunca01.contact@gmail.com">edunca01.contact[at]gmail[dot]com</a></span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
